const validate = values => {
  const errors = {};

  if (values.name?.touched) {
    if (!values.name.value) {
      errors.name = 'Your name is required.';
    }
  }

  if (values.email?.touched) {
    if (!values.email.value) {
      errors.email = 'Your email is required.';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]+$/i.test(values.email.value)) {
      errors.email = 'Invalid email address.';
    }
  }

  if (values.message?.touched) {
    if (!values.message.value) {
      errors.message = 'A message is required.';
    }
  }

  return errors;
};

export default validate;
